import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Avatar from '@components/@core/Avatar';
import Thumbnail from '@components/@core/Thumbnail';

const AdsCard = ({ className, data, size }) => (
    <div className={cx('advertising-card', className, size)} onClick={() => window.open(data?.url__target, '_blank')}>
        {size === 'tiny' && (
            <>
                <div className="d-h-start">
                    <Avatar className="mr-3" url={data?.sponsor_avatar__300} name="A D" />
                </div>
                <div className="d-flex-1">
                    <p className="dsl-b14 bold truncate-one mb-1">{data?.title}</p>
                    <p className="dsl-m12 text-400 mb-0">{`Sponsored by ${data?.sponsor}`}</p>
                </div>
            </>
        )}
        {size === 'small' && (
            <div className="d-h-start">
                <div className="d-flex-2 pe-3">
                    <Thumbnail source={data?.img_small__300} size="responsive" />
                </div>
                <div className="d-flex-3">
                    <p className="dsl-b16 bold mb-0">{data?.title}</p>
                    <p className="dsl-b14 mt-2 mb-0 truncate-two">{data?.description}</p>
                </div>
            </div>
        )}
        {size === 'medium' && (
            <>
                <div className="d-h-between">
                    <div className="d-flex ai-center">
                        <Avatar className="mr-2" url={data.sponsor_avatar__300} />
                        <div className="d-flex-1">
                            <p className="dsl-b14 text-500 mb-1">{data?.sponsor}</p>
                            <p className="dsl-b12 mb-0">Sponsored Post</p>
                        </div>
                    </div>
                </div>
                <p className="dsl-b18 bold my-3">{data?.title}</p>
                <Thumbnail source={data?.img_medium__800} size="responsive" />
                <p className="dsl-b14 mt-3 mb-0">
                    {data?.description ? `${data?.description.substring(0, 180)}...` : ''}
                    <span className="dsl-read-more">Read more</span>
                </p>
            </>
        )}
    </div>
);

AdsCard.propTypes = {
    className: PropTypes.string,
    data: PropTypes.shape({
        title: PropTypes.string,
        img: PropTypes.string,
        img_small__300: PropTypes.string,
        img_medium__800: PropTypes.string,
        sponsor: PropTypes.string,
        url__target: PropTypes.string,
    }),
    size: PropTypes.oneOf(['tiny', 'small', 'medium']),
};

AdsCard.defaultProps = {
    className: '',
    data: {
        title: '',
        img: '',
        img_small__300: '',
        img_medium__800: '',
        sponsor: '',
        description: '',
        url__target: '',
    },
    size: 'small',
};

export default AdsCard;
